import Typography from "@mui/material/Typography";
import { FilterMethod } from "@/generated/company-search";
import type { FilterChip } from "../../types";
import { defaultKnownCompaniesSlice, type KnownCompaniesSlice } from "./slice";

/**
 * Generates the chip for the known companies filter (SUCCESS state only).
 */
export function getChips(
  slice: KnownCompaniesSlice,
  setSlice: (slice: KnownCompaniesSlice) => void
): FilterChip[] {
  if (slice.uploadState !== "SUCCESS" || !slice.identifier) {
    return [];
  }

  const matched = slice.matchedRows ?? 0;
  const total = slice.totalRows ?? 0;
  const excluded = slice.filterMethod === FilterMethod.EXCLUDE_MATCHED;

  const tooltipContent = (
    <>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 500, color: "#424242", mb: 0.5 }}
      >
        Known Companies
      </Typography>
      {slice.fileName && (
        <Typography
          variant="body2"
          sx={{ fontSize: 12, color: "#666", py: 0.25 }}
        >
          File: {slice.fileName}
        </Typography>
      )}
      <Typography
        variant="body2"
        sx={{ fontSize: 12, color: "#666", py: 0.25 }}
      >
        Matched: {matched} of {total}
      </Typography>
      {excluded && (
        <Typography
          variant="body2"
          sx={{ fontSize: 12, color: "#666", py: 0.25 }}
        >
          Excluding these companies (Whitespace)
        </Typography>
      )}
    </>
  );

  return [
    {
      id: "knownCompanies",
      label: `Known Companies${excluded ? " (excluded)" : ""}: ${matched} of ${total} matched`,
      filterKey: "knownCompanies" as const,
      onRemove: () => setSlice(defaultKnownCompaniesSlice),
      tooltipContent,
    },
  ];
}

/** Returns 1 when the filter is active, 0 otherwise. */
export function getCount(slice: KnownCompaniesSlice): number {
  return slice.uploadState === "SUCCESS" && slice.identifier ? 1 : 0;
}
